import dayjs from 'dayjs'

// next date related

export const calculateNextVisitDate = (
  nextVisitInputValue,
  nextVisitInputType,
  therapyDate,
  format,
) => {
  // Validate inputs
  if (!nextVisitInputValue || !nextVisitInputType) {
    return format ? '' : null
  }

  // Clone the date to avoid mutating the original
  const currentDate = therapyDate ? dayjs(therapyDate) : dayjs()

  // Map the input type to the corresponding moment method
  const methodMap = {
    days: 'add',
    months: 'add',
    weeks: 'add',
  }

  // Calculate the next visit date based on input type and value
  if (methodMap[nextVisitInputType]) {
    currentDate[methodMap[nextVisitInputType]](nextVisitInputValue, nextVisitInputType)
  } else {
    console.error('Invalid input type')
    return format ? '' : null
  }

  if (format) {
    return currentDate.format(format)
  }
  // Return the formatted date (you can adjust the format based on your needs)
  return currentDate.format('DD/MM/YYYY')
}

